import React from 'react';
import { motion } from 'framer-motion';
import { Map, Radio, Zap } from 'lucide-react';
const features = [{
  icon: Map,
  title: 'Astral Lens',
  description: 'Interactive star map with real-time positioning, deep-sky object catalog, and augmented reality overlay.',
  color: 'from-blue-500 to-cyan-400'
}, {
  icon: Radio,
  title: 'Orbit Pulse',
  description: 'Track satellites, the ISS, and custom objects across the sky with sub-second precision.',
  color: 'from-purple-500 to-pink-400'
}, {
  icon: Zap,
  title: 'Nova Beacon',
  description: 'Personalized alerts for meteor showers, eclipses, conjunctions, and optimal viewing conditions.',
  color: 'from-amber-400 to-orange-500'
}];
export function FeaturesSection() {
  return <section id="features" className="py-24 relative z-10 bg-slate-900/20" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center mb-20" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-14">
            Your Observatory, Everywhere
          </h2>
          <div className="h-1 w-20 bg-gradient-to-r from-cyan-500 to-blue-600 mx-auto rounded-full" data-id="element-15" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-16">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative group h-full" data-id="element-17">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl opacity-20 group-hover:opacity-60 blur transition duration-500" data-id="element-18" />
              <div className="relative h-full p-8 bg-[#0d1333] rounded-2xl border border-slate-800 backdrop-blur-xl flex flex-col items-center text-center" data-id="element-19">
                {/* Constellation decoration */}
                <svg className="absolute top-4 right-4 w-16 h-16 opacity-20" viewBox="0 0 100 100" data-id="element-20">
                  <circle cx="20" cy="20" r="2" fill="white" data-id="element-21" />
                  <circle cx="80" cy="30" r="2" fill="white" data-id="element-22" />
                  <circle cx="50" cy="80" r="2" fill="white" data-id="element-23" />
                  <path d="M20,20 L80,30 L50,80 Z" stroke="white" strokeWidth="1" fill="none" data-id="element-24" />
                </svg>

                <div className={`p-4 rounded-full bg-gradient-to-br ${feature.color} bg-opacity-10 mb-6 shadow-lg`} data-id="element-25">
                  <feature.icon className="w-8 h-8 text-white" data-id="element-26" />
                </div>

                <h3 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-27">
                  {feature.title}
                </h3>

                <p className="text-slate-400 leading-relaxed" data-id="element-28">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}